"use client";
import { useRouter } from "next/navigation";
import { ShareFat } from "@phosphor-icons/react";
import { ShareNetwork } from "@phosphor-icons/react/dist/ssr";

const WebShare = ({ text }: { text: string }) => {
  const router = useRouter();

  const handleShareClick = async () => {
    const shareData = {
      title: document.title,
      text: "Check out this page on BhumiBoss!",
      url: window.location.href,
    };

    try {
      await navigator.share(shareData);
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  return (
    <>
      {typeof navigator !== 'undefined' && typeof navigator.share === "function" && (
        <div className="flex flex-row border-2 p-2 rounded-lg cursor-pointer" onClick={handleShareClick}>
          <div className="flex items-center gap-2 text-sm md:text-regular">
            <ShareNetwork className="w-4 h-4" />
            Share comparison
          </div>
        </div>
      )}
    </>
  );
};

export default WebShare;
